import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";
import { Controller } from "react-hook-form";

interface CustomDropdownProps {
  control: any;
  name: string;
  options: readonly string[];
  errors?: any;
  label: string;
  clearErrors?: () => void;
  className?: string;
  border?: boolean;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
  control,
  name,
  options,
  errors,
  label,
  clearErrors,
  className,
  border = true,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className={`relative ${className}`}>
          <Popover className="relative">
            {({ open, close }) => (
              <>
                <Popover.Button
                  className={`block w-full text-left  
dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 ${
                    errors ? "border-red-500" : ""
                  } ${
                    border
                      ? "border border-neutral-200 focus:border-primary-300 dark:border-neutral-700 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:focus:ring-primary-6000 dark:focus:ring-opacity-25"
                      : ""
                  }`}
                >
                  <div
                    className={`flex items-center justify-between`}
                    role="button"
                  >
                    <span
                      className={`${
                        field.value ? "text-neutral-900" : "text-neutral-500"
                      }`}
                    >
                      {field.value && field.value !== ""
                        ? field.value
                        : label || "Select an option"}
                    </span>
                    <ChevronDownIcon
                      className={`ml-2 h-5 w-5 text-neutral-700 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                      aria-hidden="true"
                    />
                  </div>
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-200"
                  enterFrom="opacity-0 translate-y-1"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-150"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 translate-y-1"
                >
                  <Popover.Panel className="absolute z-40 w-full mt-2 transform">
                    <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="relative max-h-60 overflow-y-auto bg-white dark:bg-neutral-800 p-2 ">
                        {options.map((option, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              field.onChange(option);
                              clearErrors && clearErrors();
                              close();
                            }}
                            className={`cursor-pointer flex items-center p-2 -m-1 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-700 focus:outline-none`}
                          >
                            <div className="ml-1 space-y-0.5">
                              <p className="text-sm font-medium ">{option}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
        </div>
      )}
    />
  );
};

export default CustomDropdown;
